import { useGoBack } from 'hooks/useGoBack';
import React, { useCallback, useContext } from 'react';
import { ModalWrapper } from 'components/ModalWindows/ModalWrapper';
import { ModalToConfirm } from 'components/ModalWindows/ModalToConfirm';
import ModalSentSuccessfully from 'components/ModalWindows/ModalSentSuccessfully';
import ModalSentError from 'components/ModalWindows/ModalSentError';
import { convertUndefinedFields } from 'utils/helpers';
import { EditRestaurantContext, IEditRestaurantContext } from '../editRestaurantState/editRestaurantContext';
import { AppContext, IAppContext } from 'appState/appContext';
import { updateRestaurant } from 'backend/restaurants';

export const ModalWindows: React.FC = () => {
	const { showLoader, hideLoader } = useContext<IAppContext>(AppContext);
	const { changeTypeOfModalWindow, refetchData, dataForSubmit, typeOfModalWindow } =
		useContext<IEditRestaurantContext>(EditRestaurantContext);
	const goBack = useGoBack();

	const handleRedirect = useCallback(() => {
		goBack('/clients/restaurants');
	}, [goBack]);

	const handleSubmitMainInfo = useCallback(async () => {
		if (dataForSubmit) {
			try {
				const convertedData = convertUndefinedFields(dataForSubmit);
				showLoader();
				await updateRestaurant(convertedData);
				changeTypeOfModalWindow('success');
			} catch (err) {
				changeTypeOfModalWindow('error');
			} finally {
				hideLoader();
			}
		}
	}, [dataForSubmit]);

	const handleUpdateData = useCallback(() => {
		refetchData(true);
		changeTypeOfModalWindow(null);
	}, []);

	const handleCloseModal = useCallback(() => {
		changeTypeOfModalWindow(null);
	}, []);

	return (
		<ModalWrapper isVisible={!!typeOfModalWindow}>
			<ModalToConfirm
				onConsentEvent={handleRedirect}
				onFailureEvent={handleCloseModal}
				isVisible={typeOfModalWindow === 'toConfirmFieldsClearing'}
				description="cancelSaveInfo"
			/>
			<ModalToConfirm
				onConsentEvent={handleSubmitMainInfo}
				onFailureEvent={handleCloseModal}
				isVisible={typeOfModalWindow === 'toConfirmSubmit'}
				description="saveInfo"
			/>
			<ModalSentSuccessfully
				onConsentEvent={handleUpdateData}
				isVisible={typeOfModalWindow === 'success'}
				description="savedSuccessfully"
			/>
			<ModalSentError
				onConsentEvent={handleCloseModal}
				isVisible={typeOfModalWindow === 'error'}
				description="errorWhileSaving"
			/>
			<ModalSentError
				onConsentEvent={handleCloseModal}
				isVisible={typeOfModalWindow === 'tlsFileSizeExceeded'}
				description="fileSizeExceeded"
				translationOptions={{ size: '1MB' }}
			/>
			<ModalSentError
				onConsentEvent={handleCloseModal}
				isVisible={typeOfModalWindow === 'tlsFileTypeError'}
				description="invalidFileFormat"
				translationOptions={{ format: '.p12' }}
			/>
			<ModalSentError
				onConsentEvent={handleCloseModal}
				isVisible={typeOfModalWindow === 'charityLogoFileSizeExceeded'}
				description="fileSizeExceeded"
				translationOptions={{ size: '1MB' }}
			/>
			<ModalSentError
				onConsentEvent={handleCloseModal}
				isVisible={typeOfModalWindow === 'charityLogoFileTypeError'}
				description="invalidFileFormat"
				translationOptions={{ format: '.png' }}
			/>
		</ModalWrapper>
	);
};
